/* eslint-disable jsx-a11y/anchor-is-valid */
import { Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link, Route } from 'react-router-dom'

import styles from '../../../resources/theme/global'
import { useQueryParams } from '../../../util/utils'
import { fetchServiceCategory } from '../ServiceCategoryActions'
import { usePermissions } from '../../../hooks/usePermission'
import colors from '../../../assets/colors'

import Edit from './Edit'
import { Filter } from './Filter'
import { List } from './List'
import { useLocation } from 'react-router-dom'

export const ServiceCategory = props => {
  const { classes } = props

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canUpdate, canRead } = usePermissions()

  const location = useLocation()
  const dispatch = useDispatch()

  const filters = useQueryParams(location?.search)

  useEffect(() => {
    dispatch(
      fetchServiceCategory({
        ...filters,
        rows: filters?.rows || 10,
        page: filters?.page || 1,
      })
    )
  }, [location])

  return (
    <>
      <Grid
        container
        className={classes.pageHead}
        spacing={2}
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography
            variant="h4"
            style={{ fontSize: '20px' }}
            color={colors.primary}
          >
            Categorias de Serviço
            {/* <IconButton className={classes.questionBox}>
                <a href="" target="_blank" rel="noreferrer">
                  <Icon
                    path={mdiMessageQuestion}
                    size={1}
                    color={colors.secondary}
                    style={{
                      position: 'absolute',
                      top: '-10px',
                      right: '-10px',
                    }}
                  />
                </a>
              </IconButton> */}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Filter classes={classes} />
        </Grid>
      </Grid>

      {canUpdate('categorias-servico', permissionUser) && (
        <Route path="/service-category/:id/edit" component={Edit} />
      )}

      {canRead('categorias-servico', permissionUser) && (
        <List classes={classes} />
      )}
    </>
  )
}

export default withStyles(styles)(ServiceCategory)
